module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_yq_dsj.34f3cace.png";